import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import useSWR from 'swr'
import ReachBarChart from 'pages/Review/components/BarChart'
import DateRange from '../OverviewChart/DateRange'
import { FormProvider, useForm } from 'react-hook-form'

export default withTranslation()(function ReviewOverview({ t }) {
  const [params, setParams] = useState({ start: '', end: '' })
  const { data: stats } = useSWR(`dashboard/ratings?${params.start ? 'start=' + params.start : ''}${params.end ? '&end=' + params.end : ''}`)

  const getParam = (value) => {
    if (value[0]) setParams((current) => ({ ...current, start: dayjs(value[0]).format('YYYY-MM-DD') }))
    if (value[1]) setParams((current) => ({ ...current, end: dayjs(value[1]).format('YYYY-MM-DD') }))
  }
  const methods = useForm({ mode: 'all' })

  return (
    <div className="w-full rounded-2xl border border-border-lines p-4">
      <div className="flex items-center justify-between mb-3">
        <p className="text-base font-semibold text-dark-blue">{t('overview.review_ratings')}</p>
        <FormProvider {...methods}>
          <DateRange name="date_range" className="w-fit" getRange={getParam} />
        </FormProvider>
      </div>

      <div className="flex items-baseline gap-2 mb-2">
        <p className="text-3xl font-bold text-dark-blue">{stats?.data?.rating || '0.0'}</p>
        <p className="text-sm text-secondary">{t('overview.out_of_five')}</p>
        <p className="text-sm text-secondary">&middot; {stats?.data?.total || 0} {t('overview.reviews')}</p>
      </div>

      <ReachBarChart data={stats?.data?.data} reversed />
    </div>
  )
})
